/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {CRMAccountVO} from '@well/domain';
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';

@Injectable({
  providedIn: 'root'
})
export class CRMAccountVoResourceService extends SelectableResourceService<CRMAccountVO> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('crmAccountUrl'),
      CRMAccountVO
    );
  }
}
